module.exports = __webpack_public_path__ + "img/icon_003.2ec0a35.webp";